import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  connect() {
    this.snapshot = this.takeSnapshot()
    this.timeout = null
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
      this.timeout = null
    }
  }

  submit() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    this.timeout = setTimeout(() => {
      this.element.requestSubmit()
      this.timeout = null
    }, 150)
  }

  handleSubmitEnd(event) {
    if (event.detail.success) {
      this.snapshot = this.takeSnapshot()
    } else {
      this.revertCheckboxes()

      if (!event.detail.fetchResponse) {
        this.injectErrorToast()
      }
    }
  }

  takeSnapshot() {
    return this.checkboxTargets.map(checkbox => checkbox.checked)
  }

  revertCheckboxes() {
    this.checkboxTargets.forEach((checkbox, index) => {
      checkbox.checked = this.snapshot[index]
    })
  }

  injectErrorToast() {
    const container = document.querySelector("#toast-container")
    if (!container) return

    container.innerHTML = `
      <div id="toast-message"
           role="alert"
           data-controller="toast"
           data-toast-auto-dismiss-value="3000"
           data-action="mouseenter->toast#pause mouseleave->toast#resume focusin->toast#pause focusout->toast#resume"
           class="pointer-events-auto w-full max-w-sm flex items-center justify-between border shadow-2xl rounded-none transition-all duration-300 ease-out transform bg-red-900 dark:bg-red-950 text-white border-l-4 border-l-red-500 border-t border-r border-b border-red-800">
        <div class="flex items-center gap-3 py-3 px-4 min-w-0">
          <span class="material-icons text-red-300 text-lg leading-none shrink-0" aria-hidden="true">error_outline</span>
          <p class="text-xs font-bold uppercase tracking-wider truncate mb-0 select-none">Failed to save preferences</p>
        </div>
        <button type="button"
                data-action="toast#dismiss"
                class="min-w-[44px] min-h-[44px] flex items-center justify-center p-3 border-l border-red-800 text-red-200 hover:text-white hover:bg-red-800/50 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-red-400 focus-visible:ring-inset"
                aria-label="Dismiss notification">
          <span class="material-icons text-base leading-none" aria-hidden="true">close</span>
        </button>
      </div>
    `


  }
}
